/**
 * EmailListContainer
 * --
 */
import React from 'react';
import EmailListPresenter from './EmailListPresenter';

const EmailListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <EmailListPresenter />
    </>
  );
};

export default EmailListContainer;
